// Haptic feedback utility for mobile devices

/**
 * Triggers haptic feedback if available on the device
 * @param {string} type - Type of haptic: 'success', 'warning', 'error', or 'light'
 */
export const triggerHaptic = (type = 'light') => {
  // Check if vibration API is available
  if (!navigator.vibrate) {
    return;
  }

  const patterns = {
    light: 50,           // Quick tap for button press
    success: [50, 50, 50], // Short double pulse for successful actions
    warning: [100, 50, 100], // Medium double pulse for warnings
    error: [200, 100, 200, 100, 200] // Long triple pulse for errors
  };

  const pattern = patterns[type] || patterns.light;
  navigator.vibrate(pattern);
};

/**
 * Success haptic feedback (add to cart, order placed)
 */
export const hapticSuccess = () => triggerHaptic('success');

/**
 * Light haptic feedback (button tap)
 */
export const hapticLight = () => triggerHaptic('light');

/**
 * Warning haptic feedback (item removed)
 */
export const hapticWarning = () => triggerHaptic('warning');

/**
 * Error haptic feedback (validation error)
 */
export const hapticError = () => triggerHaptic('error');
